import React, { Component } from 'react';

import { withLocalize } from "react-localize-redux";
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
import { Bar } from 'react-chartjs-2';
import { BarElement } from 'chart.js';
import {CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title} from 'chart.js'
Chart.register(ArcElement, Tooltip, Legend, CategoryScale,
    BarElement,
  LinearScale,
  PointElement,
  LineElement,
  Title
);



class BarChart extends Component { 

  render() {
    let options = {
      plugins: {
        title: {
          display: true,
          text: this.props.param[2],
        },
      },
      responsive: true,
      scales: { 
        x: { 
          stacked: true,
          title: {
            display: true,
            text: this.props.param[0],
          }, 
        },
        y: { 
          stacked: true, 
          title: {
            display: true,
            text: this.props.param[1],
          },
        },
      },
    };


    if(this.props.param){
      if(this.props.param[3]) {
        options.scales.y.max = this.props.param[3];
      }
    }

    const data = { 
      labels : this.props.data[0],
      datasets: this.props.data[1]
    }

    return (
        <div >
          <Bar options={options} data={data} />
        </div>
    )
  }

}
export default withLocalize(BarChart)